import { TooltippedIcon } from '@mews-commander/ui';
import { IconName } from '@optimus-web/icons';
import { PaymentTableRecord } from '@mews-commander/data-access';
import { isTerminalPayment } from './utils';

export const PaymentTerminalIcon = ({ value }: { value: PaymentTableRecord['data']['value'] }) =>
    isTerminalPayment(value) ? (
        <TooltippedIcon value={IconName.TerminalPayment} tooltip={value.paymentTerminal} size="small" />
    ) : null;
